import React, { useState, useEffect } from "react";
import { useUser } from "./UserContext";
import "./css/CartModal.css"; // Ensure this CSS correctly styles the modal
import { useNavigate } from "react-router-dom";
import { ClipLoader } from "react-spinners";
import { FaTrash } from "react-icons/fa";
import { Databases } from "appwrite";
import client from "./appwriteConfig";

function CartModal({ isCartOpen, onCartClose }) {
  const { cart, removeFromCart, cartLoading, updateCartItem, storage } =
    useUser();
  const navigate = useNavigate();
  const [isRedirecting, setIsRedirecting] = useState(false);
  const [quantities, setQuantities] = useState({});
  const [fashionImages, setFashionImages] = useState({});
  const [beatImages, setBeatImages] = useState({});
  const [tutorialImages, setTutorialImages] = useState({});
  const DbID = process.env.REACT_APP_DATABASE_ID;
  const BeatClxnID = process.env.REACT_APP_COLLECTION_BEATS_ID;
  const TutorialClxnID = process.env.REACT_APP_COLLECTION_TUTORIALS_ID;
  const fashionClxnID = process.env.REACT_APP_COLLECTION_FASHION_ID;
  const database = new Databases(client);
  useEffect(() => {
    const initialQuantities = {};
    cart.forEach((item) => {
      initialQuantities[item.productId] = item.quantity;
    });
    setQuantities(initialQuantities);
  }, [cart]);

  useEffect(() => {
    const fashionImg = {};
    const beatImg = {};
    const tutorialImg = {};

    cart.forEach((item) => {
      if (item.productType === "fashion") {
        fashionImg[item.productId] = item.fashionUrl || "";
      } else if (item.productType === "beat") {
        beatImg[item.productId] = item.imageUrl || "";
      } else if (item.productType === "tutorial") {
        tutorialImg[item.productId] = item.thumbnailUrl || "";
      }
    });

    setFashionImages(fashionImg);
    setBeatImages(beatImg);
    setTutorialImages(tutorialImg);
  }, [cart]);

  const totalPrice = cart.reduce(
    (acc, curr) => acc + (curr.cost || 0) * (quantities[curr.productId] || 1),
    0
  );

  if (!isCartOpen) return null;

  const handleQuantityChange = (itemId, change, stock) => {
    const currentQuantity = quantities[itemId] || 1;
    let newQuantity = currentQuantity + change;
    if (newQuantity < 1) newQuantity = 1;
    if (newQuantity > stock) newQuantity = stock;
    setQuantities((prev) => ({ ...prev, [itemId]: newQuantity }));
  };

  const handleProceedToPay = async () => {
    const updatedCart = [...cart];
    for (const productId in quantities) {
      const item = updatedCart.find((item) => item.productId === productId);
      if (item.quantity !== quantities[productId]) {
        item.quantity = quantities[productId];
        item.totalCost = item.cost * quantities[productId];
        await updateCartItem(productId, quantities[productId]);
      }
    }
    setIsRedirecting(true);
    onCartClose(); // Close the modal
    navigate("/checkout", { state: { cart: updatedCart, totalPrice } });
  };

  const handleRemoveFromCart = (productId) => {
    if (!cartLoading[productId]) {
      removeFromCart(productId);
    }
  };

  const groupedItems = groupItemsByProductType(cart);

  return (
    <div className="cart-modal-overlay" onClick={onCartClose}>
      <div className="cart-modal-content" onClick={(e) => e.stopPropagation()}>
        <span className="cart-modal-close" onClick={onCartClose}>
          &times;
        </span>
        <h2 className="cart-modal-title">Cart</h2>
        <div className="cart-modal-scrollable">
          {Object.keys(groupedItems).map((type) => (
            <div key={type}>
              <h3 className="cart-section-title">
                {type.charAt(0).toUpperCase() + type.slice(1)}
              </h3>
              <ul className="cart-modal-list">
                {groupedItems[type].map((item) => (
                  <li key={item.productId} className="cart-modal-item">
                    <div className="item-details">
                      {item.productType === "beat" && item.imageUrl && (
                        <img
                          src={item.imageUrl}
                          alt={item.productName}
                          className="cart-item-image"
                        />
                      )}

                      {item.productType === "tutorial" && item.thumbnailUrl && (
                        <img
                          src={item.thumbnailUrl}
                          alt={item.productName}
                          className="cart-item-image"
                        />
                      )}

                      {item.productType === "fashion" && item.fashionUrl && (
                        <img
                          src={item.fashionUrl}
                          alt={item.productName}
                          className="cart-item-image"
                        />
                      )}

                      <span className="cart-item-name">
                        {item.productName}
                        {item.tier && (
                          <span className="beat-tier-label">
                            {" "}
                            ({item.tier.toUpperCase()})
                          </span>
                        )}
                      </span>
                      {item.productType === "fashion" && (
                        <div className="fashion-counter1">
                          <button
                            className="counter-button"
                            onClick={() =>
                              handleQuantityChange(
                                item.productId,
                                -1,
                                item.stock
                              )
                            }
                          >
                            -
                          </button>
                          <span className="counter-number">
                            {quantities[item.productId] || 1}
                          </span>
                          <button
                            className="counter-button"
                            onClick={() =>
                              handleQuantityChange(
                                item.productId,
                                1,
                                item.stock
                              )
                            }
                          >
                            +
                          </button>
                        </div>
                      )}
                    </div>
                    <span className="cart-item-cost">
                      {item.productType === "fashion"
                        ? `₹${item.cost || 0} x ${
                            quantities[item.productId]
                          } = ₹${
                            (item.cost || 0) * (quantities[item.productId] || 1)
                          }`
                        : `₹${item.cost || 0}`}
                    </span>
                    <button
                      className="cart-modal-remove"
                      onClick={() => handleRemoveFromCart(item.productId)}
                      disabled={cartLoading[item.productId]}
                    >
                      {cartLoading[item.productId] ? (
                        <ClipLoader size={10} color="#FFF" />
                      ) : (
                        <FaTrash />
                      )}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="modalfooter">
          <div className="total-cart">Total: ₹ {totalPrice}</div>
          <div className="proceed-button">
            {cart.length > 0 && (
              <button onClick={handleProceedToPay}>Proceed to Pay</button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default CartModal;

function groupItemsByProductType(cart) {
  return cart.reduce((groups, item) => {
    const type = item.productType;
    if (!groups[type]) {
      groups[type] = [];
    }
    groups[type].push(item);
    return groups;
  }, {});
}
